import { ObjectField } from "../models/ObjectField";
import { ObjectTable } from "../models/ObjectTable";

export class DoneScreenHeaderField {
    Id: number | string | null;
    Tenant: number;
    Entity: ObjectTable | null;
    EntityCode: string | null;
    ObjectFieldCode: string | null;
    ObjectField: ObjectField | null;
    RowIndex: number;
    ColIndex: number;
}